import { Layout, Menu, Button, ConfigProvider } from 'antd';
import './App.css';
import { BrowserRouter } from 'react-router';
import AllRoutes from './routers';
import { Provider } from 'react-redux';
import { store } from './redux/store';

function App() {

  return (
    <BrowserRouter basename="/">
      <Provider store={store}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#CA9AE8',
              colorPrimaryHover: '#B085D4',
              colorPrimaryActive: '#A675C8',
            },
          }}
        >
          <AllRoutes />
        </ConfigProvider>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
